import React from 'react';
import Icon from '../../../components/Icon';
import getPaymentBadge from '../../../helpers/paymentBadge';
import { formatCurrency, formatDate } from './utils';

export default function RecentPayments({ payments, onViewAll }) {
    return (
        <div className="db-card">
            <div className="db-card-header">
                <span className="db-card-title">Recent Payments</span>
                {payments.length > 0 && <button className="db-btn-outline" onClick={onViewAll}>View All</button>}
            </div>
            {payments.length === 0 ? (
                <div className="db-empty">No Payments</div>
            ) : (
                <div className="db-table-wrap">
                    <table className="db-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Method</th>
                                <th>RECs</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.slice(0, 4).map((p) => {
                                const badge = getPaymentBadge(p.status);
                                return (
                                    <tr key={p.id}>
                                        <td>{formatDate(p.payment_date)}</td>
                                        <td>{p.method}</td>
                                        <td>{p.recs ?? '—'}</td>
                                        <td className="amount">{formatCurrency(p.amount)}</td>
                                        <td>
                                            <span className={`db-badge db-badge--${badge.modifier}`}>
                                                {badge.icon && <Icon type={badge.icon} size={12} color={badge.iconColor} />}
                                                {p.status ?? 'Completed'}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
